export const deviceStorage = {
  getItem: key => Promise.resolve()
                            .then(() => localStorage.getItem(key)),
  setItem: (key, value) => Promise.resolve()
                            .then(() => localStorage.setItem(key, value)),
  removeItem: key => Promise.resolve()
                            .then(() => localStorage.removeItem(key)),
}
